import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

export default class extends React.Component {
  static displayName = "Radio";

  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
  };

  handleChange = evnt => {
    const isChecked = this.input.checked;
    return typeof this.props.onChange === "function"
      ? this.props.onChange(this.props.name, isChecked, this.props.value, evnt)
      : undefined;
  };

  render() {
    return (
      <label className={classNames("et--radio", this.props.className)}>
        <input
          type="radio"
          className="et--radio--input"
          name={this.props.name}
          value={this.props.value}
          checked={this.props.checked}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          ref={e => {
            return (this.input = e);
          }}
        />
        <span
          className={classNames("et--radio--circle", {
            "is-disabled": this.props.disabled,
          })}
        />
        <span className="et--radio--label">{this.props.children}</span>
      </label>
    );
  }
}
